<template>
  <div>
    <DownloadScreen
      class="mb-28"
    />

    <DownloadScreen
      class="mb-28"
      :progress="progress"
    />

    <DownloadScreen
      :branding="{
        colours: {
          primary: '#f012be',
          primaryIsWhite: false,
          accentPrimary: '#7E10C1',
          accentSecondary: '#ffffff'
        },
        logo: logoWide,
        customisedBranding: true
      }"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import DownloadScreen from '@/components/screens/DownloadScreen'
import logoWide from '@/assets/designs/logo-wide.png'

const progress = ref(0)
let timeoutId = null

const simulateDownload = () => {
  // Random progress increment between 1 and 10
  const increment = Math.random() * 9 + 1
  // Random delay between 100ms and 1000ms
  const delay = Math.random() * 900 + 100

  progress.value = Math.min(100, progress.value + increment)

  if (progress.value < 100) {
    timeoutId = setTimeout(simulateDownload, delay)
  } else {
    progress.value = 100
    setTimeout(() => {
      progress.value = 0
      simulateDownload()
    }, 10000)
  }
}

onMounted(() => {
  setTimeout(() => {
    simulateDownload()
  }, 200)
})

onUnmounted(() => {
  if (timeoutId) {
    clearTimeout(timeoutId)
  }
})
</script>
